import styled from "styled-components";

export { PrimaryActionButtonForPage, PrimaryActionButtonForModal, CustomModalFooter }
    from "../../../styledComponents/styledComponents";

const TYPE_COLORS = {
    NOTA:          { bg: "#e0e7ff", color: "#3730a3" },
    OBSERVACION:   { bg: "#cffafe", color: "#0e7490" },
    CAMBIO:        { bg: "#ede9fe", color: "#6d28d9" },
    ALERTA_CONFIG: { bg: "#fef3c7", color: "#92400e" },
    CARGA_HORARIA: { bg: "#fee2e2", color: "#991b1b" },
};

export const TipoBadge = styled.span`
    display: inline-block;
    padding: 2px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    background-color: ${({ tipo }) => TYPE_COLORS[tipo]?.bg ?? "#f3f4f6"};
    color:            ${({ tipo }) => TYPE_COLORS[tipo]?.color ?? "#374151"};
    white-space: nowrap;
`;

const ESTADO_COLORS = {
    Pendiente:  { color: "#ca8a04" },
    Abierto:    { color: "#2563eb" },
    Cerrado:    { color: "#6b7280" },
    Inactivo:   { color: "#9ca3af" },
    APROBADO:   { color: "#16a34a" },
    RECHAZADO:  { color: "#dc2626" },
    RECIBIDO:   { color: "#16a34a" },
    RESUELTA:   { color: "#0891b2" },
};

export const EstadoBadge = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: ${({ estado }) => ESTADO_COLORS[estado]?.color ?? "#374151"};
`;

